<template>
  <v-container
    fluid
    class="d-flex flex-column"
    :style="{
      backgroundImage: 'url(' + require('@/assets/beon.jpg') + ')',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      height: '100vh',
      width: '100vw',
      margin: '0',
      padding: '0',
      overflow: 'hidden',
    }"
  >
    <v-layout>
      <v-flex>
        <v-row justify="center" align="center">
          <v-col cols="12" class="d-flex flex-column align-center text-center">
            <v-row justify="center" align="center" class="mt-14 my-8">
              <v-col cols="2" justify="center" align="center" class="pr-0">
                <v-img
                  contain
                  :src="require('@/assets/VP_sin_fondo.png')"
                  :class="{
                    'logo-class': $vuetify.breakpoint.smAndUp,
                    'logo-class-small': $vuetify.breakpoint.smAndDown,
                  }"
                />
              </v-col>
              <v-col cols="2" justify="center" align="center" class="pl-0">
                <v-img
                  contain
                  src="img/beonit.png"
                  :class="{
                    'logo-class': $vuetify.breakpoint.smAndUp,
                    'logo-class-small': $vuetify.breakpoint.smAndDown,
                  }"
                />
              </v-col>
            </v-row>

            <v-card v-if="!isForgotPassword" class="mt-12 mx-4 pa-6" width="500">
              <v-card-title class="justify-center mb-6">
                <h5>Log in to your account</h5>
              </v-card-title>

              <v-form v-model="validLogin" @submit.prevent="login">
                <v-card-text>
                  <v-text-field
                    id="emailLogin"
                    v-model="emailLogin"
                    class="py-0 mb-6 no-border-radius"
                    label="Email"
                    :rules="[emailLoginRules.required, emailLoginRules.email]"
                    dense
                    type="email"
                  />
                  <v-text-field
                    v-model="passwordLogin"
                    class="mb-4 no-border-radius"
                    label="Password"
                    :rules="[passwordLoginRules.required]"
                    dense
                    :type="showPassword ? 'text' : 'password'"
                    :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                    @click:append="togglePasswordVisibility"
                  />
                </v-card-text>

                <v-card-actions class="mx-2">
                  <v-btn
                    v-if="!loggingIn"
                    class="mb-2"
                    color="primary"
                    block
                    type="submit"
                    :disabled="!isValidLogin"
                  >
                    Login
                  </v-btn>
                  <v-btn v-else color="primary" block type="submit" disabled>
                    <v-progress-circular indeterminate color="primary" />
                  </v-btn>
                </v-card-actions>
              </v-form>

              <v-btn text variant="text" class="my-2" color="primary" @click="toggleForgotPassword">
                Forgot your password?
              </v-btn>

              <v-alert
                v-if="messageLogin"
                outlined
                :color="successfullLogin ? 'success' : 'error'"
                :icon="successfullLogin ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
                class="mx-2 mt-2"
              >
                {{ messageLogin }}
              </v-alert>
            </v-card>

            <v-card v-if="isForgotPassword" class="mt-12 mx-4 pa-6" width="500">
              <v-card-title class="justify-center mb-6">
                <h5>Reset your password</h5>
              </v-card-title>

              <v-form v-model="validReset" @submit.prevent="requestPasswordReset">
                <v-card-text>
                  <v-text-field
                    id="emailReset"
                    v-model="emailReset"
                    class="py-0 mb-6 no-border-radius"
                    label="Email"
                    :rules="[emailResetRules.required, emailResetRules.email]"
                    dense
                    type="email"
                  />
                </v-card-text>

                <v-card-actions class="mx-2">
                  <v-btn
                    v-if="!resettingPassword"
                    class="mb-2"
                    color="primary"
                    block
                    type="submit"
                    :disabled="!isValidRequest"
                  >
                    Request reset
                  </v-btn>
                  <v-btn v-else color="primary" block type="submit" disabled>
                    <v-progress-circular indeterminate color="primary" />
                  </v-btn>
                </v-card-actions>
              </v-form>

              <v-btn text variant="text" class="my-2" color="primary" @click="toggleForgotPassword">
                Back to login
              </v-btn>

              <v-alert
                v-if="messageReset"
                outlined
                :color="successfullReset ? 'success' : 'error'"
                :icon="successfullReset ? 'mdi-check-circle' : 'mdi-alert'"
                dismissible
                class="mx-2 mt-2"
              >
                {{ messageReset }}
              </v-alert>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Vue from 'vue';
import AuthDataService from '@/services/AuthDataService';
import SocketioService from '@/services/socketioService.js';

export default {
  name: 'LandingPage',
  data() {
    return {
      emailLogin: '',
      passwordLogin: '',
      emailReset: '',
      validLogin: false,
      validReset: false,
      messageLogin: '',
      successfullLogin: false,
      loggingIn: false,
      isForgotPassword: false,
      emailLoginRules: {
        required: (v) => !!v || 'Required field',
        email: (v) => /.+@.+\..+/.test(v) || 'Invalid email address',
      },
      emailResetRules: {
        required: (v) => !!v || 'Required field',
        email: (v) => /.+@.+\..+/.test(v) || 'Invalid email address',
      },
      passwordLoginRules: {
        required: (v) => !!v || 'Required field',
      },
      messageReset: '',
      successfullReset: false,
      resettingPassword: false,
      showPassword: false,
    };
  },
  computed: {
    isValidLogin() {
      return (
        this.emailLogin !== '' &&
        this.passwordLogin !== '' &&
        this.emailLoginRules.email(this.emailLogin) !== 'Invalid email address'
      );
    },
    isValidRequest() {
      return (
        this.emailReset !== '' &&
        this.emailResetRules.email(this.emailReset) !== 'Invalid email address'
      );
    },
  },
  mounted() {
    AuthDataService.guard().then(
      (response) => {
        if (response.status == 200) {
          this.$router.push('/home');
        }
      },
      (error) => {
        console.error((error.response && error.response.data) || error.message || error.toString());
      }
    );
  },
  methods: {
    login() {
      this.messageLogin = '';

      this.loggingIn = true;

      AuthDataService.login(this.emailLogin, this.passwordLogin).then(
        (response) => {
          if (response.status == 200) {
            localStorage.setItem('user', JSON.stringify(response.data.data));

            Vue.prototype.$socket = SocketioService.setupSocketConnection(
              JSON.parse(localStorage.getItem('user')).id,
              JSON.parse(localStorage.getItem('user')).username,
              true
            );

            this.$router.push('/home');
          } else {
            this.messageLogin = 'An error occurred while logging in. Please, try again later.';
          }

          this.loggingIn = false;
        },
        (error) => {
          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          console.error(error.response.data);

          if (error.response && error.response.status == 401) {
            if (error.response.data.code == 'ACCOUNT_NOT_ACTIVATED') {
              this.messageLogin =
                'Account not activated. Please, check your email inbox to activate your account.';
            } else if (error.response.data.code == 'UNAUTHORIZED') {
              this.messageLogin = 'Invalid password. Please use the correct one.';
            } else {
              this.messageLogin = 'An error occurred while logging in. Please, try again later.';
            }
          } else if (error.response && error.response.status == 404) {
            this.messageLogin = 'Email not found. Please, use another email.';
          } else {
            this.messageLogin = 'An error occurred while logging in. Please, try again later.';
          }

          this.loggingIn = false;
        }
      );
    },
    requestPasswordReset() {
      this.messageReset = '';

      this.resettingPassword = true;

      AuthDataService.forgotPassword(this.emailReset).then(
        (response) => {
          if (response.status == 204) {
            this.successfullReset = true;
            this.messageReset =
              'Password reset successfully requested. Please check your email inbox to reset your password.';
            this.emailReset = '';
          } else {
            this.successfullReset = false;
            this.messageReset =
              'An error occurred while requesting password. Please, try again later.';
          }

          this.resettingPassword = false;
        },
        (error) => {
          this.successfullReset = false;
          console.error(
            (error.response && error.response.data) || error.message || error.toString()
          );

          console.error('error.response: ', error.response);
          console.error('error.response.data: ', error.response.data);

          if (error.response && error.response.status == 404) {
            this.messageReset = 'User not found. Please, check if the email is correct.';
          } else if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('user');
            this.$router.push('/');
          } else {
            this.messageReset =
              'An error occurred while requesting password. Please, try again later.';
          }

          this.resettingPassword = false;
        }
      );
    },
    toggleForgotPassword() {
      this.isForgotPassword = !this.isForgotPassword;
      this.messageLogin = '';
      this.messageReset = '';
      if (this.isForgotPassword) {
        this.emailReset = '';
      } else {
        this.emailLogin = '';
        this.passwordLogin = '';
      }
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
  },
};
</script>
